import styles from './styles.module.css';

export interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTabId: string;
  onTabChange: (tabId: string) => void;
  customTabClassname?: string;
  customTabContainerClassname?: string;
  secondaryTabs?: boolean;
}

export default function Tabs({
  tabs,
  activeTabId,
  onTabChange,
  secondaryTabs = false
}: TabsProps) {
  return (
    <div
      className={
        secondaryTabs ? styles.secondaryTabsContainer : styles.tabsContainer
      }
    >
      {tabs.map(tab =>
        secondaryTabs ? (
          <button
            key={tab.id}
            className={`${styles.secondaryTab} ${activeTabId === tab.id ? styles.secondaryTabActive : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ) : (
          <button
            key={tab.id}
            className={activeTabId === tab.id ? styles.tabActive : styles.tab}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        )
      )}
    </div>
  );
}
